'use client';

import { c as _c } from "react/compiler-runtime";
import { getBreakpoints } from '@src/utils/breakpoints.util';
import { defaultTopNavProps } from './TopNav.defaults';
import { type TopNavProps } from './TopNav.props';
import { TopNavDesktop } from './TopNavDesktop';
import { TopNavMobile } from './TopNavMobile';
export const TopNav = t0 => {
  const $ = _c(3);
  const props = t0 === undefined ? defaultTopNavProps : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBreakpoints();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isMobile,
    isTablet
  } = t1;
  let t2;
  if ($[1] !== props) {
    t2 = isMobile || isTablet ? <TopNavMobile {...props} /> : <TopNavDesktop {...props} />;
    $[1] = props;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};